import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "./data";
import { Reveal } from "./Reveal";

const STATS = [
  { value: "12+", label: "Years on the tools" },
  { value: "480+", label: "Projects completed" },
  { value: "1mm", label: "Working tolerance" },
  { value: "100%", label: "Guaranteed workmanship" },
];

export const Craftsmanship = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="studio" data-testid="craftsmanship-section" className="bg-surface py-24 md:py-40 border-t border-line">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-5 md:col-start-1">
          <div ref={ref} className="relative aspect-[3/4] overflow-hidden border border-line">
            <motion.img
              style={{ y }}
              src={IMAGES.craftsman}
              alt="Craftsman laying tiles"
              className="absolute inset-0 h-[124%] w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-terracotta/20" />
          </div>
        </Reveal>

        <div className="md:col-span-6 md:col-start-7">
          <Reveal>
            <p className="font-heading text-xs uppercase tracking-[0.3em] font-bold text-terracotta mb-6">
              [ 04 ] — The studio
            </p>
            <h2 className="font-heading font-extrabold uppercase text-bone tracking-tight leading-[0.9] text-4xl md:text-5xl lg:text-6xl mb-8">
              Built by hand.<br />Backed by trade.
            </h2>
            <p className="font-body font-light text-stone text-base md:text-lg leading-relaxed max-w-xl mb-6">
              MG Tiling Pro is a specialist Dublin tiling company run by Mihai. We take
              on fewer projects so every joint gets the attention it deserves. Fully
              insured, time-served and obsessive about the finish.
            </p>
            <p className="font-body font-light text-stone text-base md:text-lg leading-relaxed max-w-xl">
              No subcontracted crews, no shortcuts — just the same set of hands from
              set-out to final silicone bead.
            </p>
          </Reveal>

          <div className="grid grid-cols-2 gap-px bg-line border border-line mt-12">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08}>
                <div className="bg-surface p-8">
                  <div className="font-heading text-4xl md:text-5xl font-black text-bone mb-2">
                    {s.value}
                  </div>
                  <div className="font-heading text-xs uppercase tracking-[0.2em] font-bold text-stone">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
